// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"HolisticEducation_innerContainer___Vzh8","left":"HolisticEducation_left__W2hfw","right":"HolisticEducation_right__Eqydw"};